// Gera um slug de loja a partir do nome da empresa.
// Ex: "Matriz 3D" -> "matriz3d", "Print Control!" -> "printcontrol"
const ACENTOS = new RegExp("[\\u0300-\\u036f]", "g");

export function gerarSlug(nome) {
  return (nome || "")
    .normalize("NFD")
    .replace(ACENTOS, "")        // remove acentos
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");  // só letras e números
}
